export const dateFormatter = (cell, row) => {
  const date = new Date(cell);
  return date.toUTCString().replace(" GMT", "");
};

export const dateInputFormatter = (cell, row) => {
  return cell.split("T")[0];
};

function isValidDate(dateString) {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
}

/**
 * 
 * @param {string} cell 
 * @param {*} row 
 * @returns 
 */
export const dateReportFormatter = (cell, row) => {
  if (!cell) return cell;
  if (!isValidDate(cell)) return cell;
  if (cell?.toLowerCase()?.includes("totals")) return cell;
  const date = new Date(cell);
  return date
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    })
    .replace(",", "");
};

export const dateTimeReportFormatter = (cell, row) => {
  if (!cell) return cell;
  if (!isValidDate(cell)) return cell;
  if (cell?.toLowerCase()?.includes("totals")) return cell;
  const date = new Date(cell);
  return date
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
    .replace(",", "");
}

export const dateTimeReportFormatter2 = (cell, row) => {
  if (!cell) return cell;
  if (!isValidDate(cell)) return cell;
  if (cell?.toLowerCase()?.includes("totals")) return cell;
  const date = new Date(cell);
  return date
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }) + "<br>" + 
    date.toLocaleTimeString("en-US", {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
}




export const durationReportFormatter = (cell, row) => {
  const secondsPerHour = 3600;
  const secondsPerMinute = 60;

  let hours = Math.floor(cell / secondsPerHour);
  let minutes = Math.floor((cell % secondsPerHour) / secondsPerMinute);
  let seconds = Math.floor(cell % secondsPerMinute);

  return `${hours}h ${minutes}m ${seconds}s`;
};
